import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationScanRunStopArgs, ScanRun } from "types/generated";

type ScanRunStopData = {
  scanRunStop: Pick<ScanRun, "id" | "state" | "note">;
};

export const SCAN_RUN_STOP: TypedDocumentNode<ScanRunStopData, MutationScanRunStopArgs> = gql`
  mutation ScanRunStop($id: ID!, $note: String) {
    scanRunStop(id: $id, note: $note) {
      id
      state
      note
    }
  }
`;
